import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { CircularProgress } from "@material-ui/core";
import ShareVideoPopUp from "./ShareVideoPopUp";

export default function VideoIframe({ showVideo, handleClose, src }) {
    const [frameloaded, setFrameLoaded] = useState(false);
    const [showimage, setShowImage] = useState(false);

    const FrameFunction = () => {
        setFrameLoaded(true);
    };

    const handleShare = (video) => {
        navigator.clipboard.writeText(video);
        console.log("Video URL copied to clipboard:", video);
        setShowImage(true);
    };

    return (
        <div>
            <Modal
                show={showVideo}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                dialogClassName="custom-modal"
                centered
            >
                <Modal.Body>
                    <div className="video-container">
                        {frameloaded ? (
                            ""
                        ) : (
                            <div className="loader-container">
                                <CircularProgress className="mr-2" />
                                <h6>Please Wait...</h6>
                            </div>
                        )}
                        <iframe
                            id="iframedata"
                            title="Video"
                            src={src}
                            style={{
                                display: frameloaded ? "block" : "none",
                                border: "none", // Remove any border
                            }}
                            onLoad={FrameFunction}
                            onError={() => console.log("ERRORRRRRRR")}
                            allowFullScreen
                            frameBorder="0"
                            className="video-iframe"
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleShare(src)}>
                        Share
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <ShareVideoPopUp
                show={showimage}
                onClose={() => setShowImage(false)}
                src={src}
            />
        </div>
    );
}
